// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"18bb91bf","893":"5afaddc7"}[chunkId] + ".chunk.js";
};